import React from 'react';
import PropTypes from 'prop-types';

const ImageComponent = ({
  fileName,
  className,
  onClick,
  onKeyDown, // support keyboard interaction
  width = "auto",
  height = "auto",
  alt,
  role,
  tabIndex,
  style
}) => {
  const imagePath = require(`../../../assets/img/${fileName}`);
  
  return (
    <img loading="lazy"
      src={imagePath}
      className={className}
      alt={alt}
      width={width}
      height={height}
      style={style}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
    />
  );
};

// Optional: Add PropTypes for better validation
ImageComponent.propTypes = {
  fileName: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alt: PropTypes.string.isRequired,
  role: PropTypes.string,
  tabIndex: PropTypes.number,
  style: PropTypes.object,
};

export default ImageComponent;